/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import cn from 'classnames'
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import hourglassFullStyles from './StyledHourglassFullIcon.styles'
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import Avatar from '@material-ui/core/Avatar'

const StyledHourglassFullIcon = ({ classes, size = 'md' }) => {
  return (
    <Avatar className={
        cn(classes.avatar, {
          [classes.lg]: size === 'lg',
        })
      }
    >
      <HourglassFullIcon
        className={
          cn(classes.icon, {
            [classes.lgIcon]: size === 'lg',
          })
        }
      />
    </Avatar>
  )
}

StyledHourglassFullIcon.propTypes = {
  classes: ThemeStatePropTypes.classes.isRequired,
  size: PropTypes.string,
}

export default withStyles(themeCreateInjectableStyles(hourglassFullStyles), { withTheme: true })(StyledHourglassFullIcon)
